export function NotFound() {
  return (
    <div className="p-8">
      <h2 className="text-xl font-semibold">Page not found</h2>
    </div>
  );
}
